import { hashKey } from '@tanstack/react-query';

// Revocation survives query removal/recreation, but never outlives its client.
const revisions = new WeakMap();
export const getQueryProjectionRevision = (client, key) => revisions.get(client)?.get(hashKey(key)) || 0;
export const revokeQueryProjection = (client, key) => {
  if (!revisions.has(client)) revisions.set(client, new Map());
  revisions.get(client).set(hashKey(key), getQueryProjectionRevision(client, key) + 1);
};
export const captureQueryProjection = (client, key) => {
  const revision = getQueryProjectionRevision(client, key);
  return () => revision === getQueryProjectionRevision(client, key);
};
